import { render, staticRenderFns } from "./HomeCert.vue?vue&type=template&id=6e4d807a&scoped=true&"
import script from "./HomeCert.vue?vue&type=script&lang=js&"
export * from "./HomeCert.vue?vue&type=script&lang=js&"
import style0 from "./HomeCert.vue?vue&type=style&index=0&id=6e4d807a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d807a",
  null
  
)

export default component.exports